// The public site's shared English messages (site/core and the labels
// layer's ui): every template reads these. fr.ts / es.ts mirror them.
// Template-specific copy lives in site-<template> namespaces (#1119–#1121).
// The labels layer and core's pages keep theirs in labels/ and pages/ (#1118);
// the member and registration pages keep theirs in member/ (#1448).
import labels from './labels/en'
import pages from './pages/en'
import widgets from './widgets/en'
import member from './member/en'

const en = {
  labels,
  pages,
  widgets,
  member,
  common: {
    errorTitle: 'Something went wrong',
    /** The one friendly line for a failed load (#420). */
    loadError: "We couldn't load this right now. Please try again.",
    tbd: 'TBD',
    retry: 'Try Again',
    loading: 'Loading...',
    notFoundTitle: 'Page not found',
    notFoundBody: "We couldn't find that page.",
    nextUp: 'Next up',
    /** Under ~90px: a game past its start with no score yet. */
    awaitingResultShort: 'Awaiting',
  },
  standings: {
    /** #710: under a capped stacked card (5+ divisions); opens Schedule's stacked standings. */
    seeAll: 'See all standings',
    /** #710: under each division's table on a stacked standings card; opens that division's schedule. */
    fullTable: 'Full table',
    noData: 'No standings data',
  },
  footer: {
    /** The fan language switch's label (#1117); each language is named in its own words. */
    language: 'Language',
    /** Footer links, gated by the league's site sections. */
    links: {
      schedule: 'Schedule',
      players: 'Players',
      teams: 'Teams',
      stats: 'Stats',
      gallery: 'Gallery',
      blog: 'Blog',
      venues: 'Venues',
    },
  },
}

export default en
